@if(message) {
	<div class="popup-backdrop">
		<div class="confirm-popup-container">
			<div class="confirm-popup-header">
				<span>{{ displayTitle }}</span>
				<button class="close-btn" (click)="onConfirm()" aria-label="סגור">×</button>
			</div>
			<div class="confirm-popup-content">
				<div class="confirm-popup-message" [class.multiline]="message.includes('\n')">
					{{ message }}
				</div>
				<div class="confirm-popup-actions">
					<button class="confirm-btn" (click)="onConfirm()" i18n="components.popup.confirm">אישור</button>
				</div>
			</div>
		</div>
	</div>
}
